import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
// import { AuthProvider } from './components/AuthContext';
import Dashboard from './pages/Dashboard';
// import BlogPage from './pages/BlogPage'
// import AboutUsPage from './pages/AboutUsPage'
// import ProductPage from './pages/ProductPage';
// import ProductionPage from './pages/ProductionPage';
// import GetInTouchPage from './pages/GetInTouchPage';
// import LoginPage from './pages/LoginPage';
// import ProductDetailPage from './pages/ProductDetailPage';
// import ProductSearchPage from './pages/ProductSearchPage';
// import CustomizedProcessPage from './pages/CustomizedProcessPage';
// import SampleProductionPage from './pages/SampleProductionPage';
// import MoqPage from './pages/MoqPage';
// import PackingPage from './pages/PackingPage';
// import QualityControlPage from './pages/QualityControlPage';
// import ExamplePage from './pages/ExamplePage';
// import Header from './components/Header';
// import ProductManagementPage from './pages/ProductManagementPage';
// import ManagementPage from './pages/ManagementPage';
import FloatingMessageBox from './components/FloatingMessageBox';
// import NewsPage from './pages/NewsPage';
// import NewsDetailPage from './pages/NewsDetailPage';
// import BlogDetailPage from './pages/BlogDetailPage';
import { useLocation } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
// 111

const Blog = React.lazy(() => import('./pages/BlogPage'));
const AboutUs = React.lazy(() => import('./pages/AboutUsPage'));
const Product = React.lazy(() => import('./pages/ProductPage'));
const GetInTouch = React.lazy(() => import('./pages/GetInTouchPage'));
const Login = React.lazy(() => import('./pages/LoginPage'));
const Management = React.lazy(() => import('./pages/ManagementPage'));
const News = React.lazy(() => import('./pages/NewsPage'));
const CustomizedProcess = React.lazy(() => import('./pages/CustomizedProcessPage'));
const SampleProduction = React.lazy(() => import('./pages/SampleProductionPage'));
const Moq = React.lazy(() => import('./pages/MoqPage'));
const Packing = React.lazy(() => import('./pages/PackingPage'));
const QualityControl = React.lazy(() => import('./pages/QualityControlPage'));
const Example = React.lazy(() => import('./pages/ExamplePage'));

const PageList = () => {
  const location = useLocation();
  const hideFloatingMessageBox = location.pathname.startsWith('/Management') || location.pathname.startsWith('/Login');
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* <Route path="/dashboard" element={<Dashboard token={token} setToken={setToken} />} /> */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/Blog/*" element={<Blog />} />
          {/* <Route path="/Blog" element={<BlogPage />} />
          <Route path="/Blog/:blogId" element={<BlogDetailPage />} /> */}
          <Route path="/AboutUs" element={<AboutUs />} />
          {/* <Route path="/Product" element={<ProductPage />} />
          <Route path="/Product/:ProductId" element={<ProductDetailPage />} />  
          <Route path="/Product/search/:keyword" element={<ProductSearchPage />} /> */}
          <Route path="/Product/*" element={<Product />} />
          <Route path="/GetInTouch" element={<GetInTouch />} />
          <Route path="/Login" element={<Login />} />
          <Route 
            path="/Management"
            element={
              <ProtectedRoute>
                <Management />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:newsId" element={<NewsDetailPage />} /> */}
          <Route path="/News/*" element={<News />} />
          <Route path="/customizedProcess" element={<CustomizedProcess />} />
          <Route path="/SampleProduct" element={<SampleProduction />} />
          <Route path="/moq" element={<Moq />} />
          <Route path="/packing" element={<Packing />} />
          <Route path="/qualityControl" element={<QualityControl />} />
          <Route path="/examples" element={<Example />} />
        </Routes>
      </Suspense>
      {!hideFloatingMessageBox && <FloatingMessageBox />}
    </>
  );
}

export default PageList;